function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M24399.285-5483.069a.336.336 0 0 1-.27-.2.322.322 0 0 1 .07-.334l9.32-10.341 4.461-4.939a.322.322 0 0 1 .465-.033l1.531 1.367c.066.035.1.135.137.235a.369.369 0 0 1-.1.234l-4.262 4.7 1.262 1.167a.292.292 0 0 1 .1.233.339.339 0 0 1-.1.233l-3.926 4.337a10.1 10.1 0 0 1-3.66 2.6h4.527a.314.314 0 0 1 .332.334.315.315 0 0 1-.332.334h-6.824a9.337 9.337 0 0 1-1.668.133c-.364.009-.731-.027-1.063-.06zm12.918-.065a.317.317 0 0 1-.336-.334.316.316 0 0 1 .336-.334h.828a.336.336 0 0 1 .336.334.317.317 0 0 1-.336.334zm-1.969 0a.315.315 0 0 1-.332-.334.314.314 0 0 1 .332-.334h.836a.314.314 0 0 1 .332.334.315.315 0 0 1-.332.334z",
  transform: "translate(-24394.996 5503.001)"
}));

function SvgCaseDes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDes);
export default __webpack_public_path__ + "static/media/caseDes.8f15a436.svg";
export { ForwardRef as ReactComponent };